<template>
  <div>
    <New-spaperInfoList showingPage="fourhundred"></New-spaperInfoList>
  </div>
</template>

<script>
  import NewspaperInfoList from '../../../components/newspaperInfoList.vue' 
   export default {
    name:'/manage/main.maintainInfo400',
   components: {
      'New-spaperInfoList': NewspaperInfoList 
    },
    data () {
      return {}
    },
    created() {
      setTimeout(() => {
         window.localStorage.setItem('fourbsform', '')
         window.localStorage.setItem('fourbsfileList', '')
         window.localStorage.setItem('fourbsfileListfj', '')
      }, 200)
    },
    computed: {},
    watch: {},
    methods: {
    
  },
}
</script>
<style lang='scss'>
 
</style>
